/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconZoomCode = createReactComponent("zoom-code", "IconZoomCode", [
  ["path", { d: "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", key: "svg-0" }],
  ["path", { d: "M21 21l-6 -6", key: "svg-1" }],
  ["path", { d: "M8 8l-2 2l2 2", key: "svg-2" }],
  ["path", { d: "M12 8l2 2l-2 2", key: "svg-3" }]
]);

export { IconZoomCode as default };
//# sourceMappingURL=IconZoomCode.js.map
